<template>
  <brazil-field
    :input-id="inputId"
    :label="label"
    :validator-field="validatorField"
    :validator-key="validatorKey"
  >
    <select
      :id="inputId"
      v-model="validatorField.$model"
      :name="name"
      :class="status"
      :disabled="disabled"
      @blur="validatorField.$touch"
      @change="$emit('change', true)"
    >
      <option
        v-if="showDefaultOption"
        :value="null"
      >
        Por favor selecione
      </option>
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.text }}
      </option>
    </select>
    <template v-slot:note>
      <slot name="note" />
    </template>
  </brazil-field>
</template>
<script>
import { get } from 'vuex-pathify';
import BrazilField from './BrazilField.vue';

export default {
  components: {
    BrazilField,
  },
  props: {
    name: {
      type:     String,
      required: true,
    },
    inputId: {
      type:     String,
      required: true,
    },
    label: {
      type:     String,
      required: true,
    },
    validatorField: {
      type:     Object,
      required: true,
    },
    options:      { type: Array, required: true },
    validatorKey: {
      type:    String,
      default: null,
    },
  },
  data() {
    return {
      cachedStatus:      null,
      showDefaultOption: true,
    };
  },
  computed: {
    status() {
      if (!this.validatorField.$pending || this.cachedStatus === null) {
        /* eslint-disable-next-line vue/no-side-effects-in-computed-properties */
        this.cachedStatus = {
          valid: this.validatorField.$dirty && !this.validatorField.$error,
          error: this.validatorField.$error,
        };
      }
      return this.cachedStatus;
    },
    disabledFields: get('registration/disabledFieldNames'),
    disabled() {
      return this.disabledFields.includes(this.name);
    },
  },
  created() {
    if (this.validatorField.$model) { return; }
    const defaultOption = this.options.find((o) => o.selected === true);
    if (defaultOption !== undefined) {
      this.validatorField.$model = defaultOption.value;
      this.validatorField.$reset();
      this.showDefaultOption = false;
    }
  },
};
</script>
